import api from '../token';

export const DeleteFamilia = async (dados) => {
  try {
    const response = await api.post('/deleteFamilia', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};